import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async initializeLtiDataForClass(_, classId) {
    const response = await axios.post(`/blade/classes/${classId}/lti/create`);
    return response;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/lti.js